import { Grid, Typography, styled } from "@mui/material";

export const StyledGrid = styled(Grid)({
  width: "min(100%, 600px)",
  "& svg[data-icon='money-bill-wave']": {
    marginTop: "3px",
  },
});

export const SubHeadingContainer = styled(Grid)(({ theme }) => ({
  marginBottom: "24px",
  [theme.breakpoints.up("sm")]: {
    marginBottom: "32px",
  },
}));

export const SubHeadingTypography = styled(Typography)(({ theme }) => ({
  fontsize: "26px",
  textAlign: "center",
  [theme.breakpoints.up("sm")]: {
    fontSize: "40px",
  },
}));

export const TitleTypography = styled(Typography)({
  fontWeight: 400,
  fontSize: "18px",
});
